import { ColumnHeaderHelp } from '../shared/ColumnHeaderHelp';
import { glossaryText } from '../../utils/weldFieldGlossary';
import { sectionSubtitleClass, sectionTitleClass } from './dashboardTokens';

interface DashboardSectionHeaderProps {
  title: string;
  subtitle?: string;
  helpKey: string;
  className?: string;
}

export const DashboardSectionHeader = ({
  title,
  subtitle,
  helpKey,
  className = '',
}: DashboardSectionHeaderProps) => (
  <div className={className}>
    <p className={sectionTitleClass}>
      <ColumnHeaderHelp label={title} help={glossaryText(helpKey)} />
    </p>
    {subtitle && <p className={sectionSubtitleClass}>{subtitle}</p>}
  </div>
);
